module.exports = __webpack_public_path__ + "img/instagram.e84f88d6.svg";